import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import type ReactRendererService from 'garaje/services/react-renderer';
import type { Root } from 'react-dom/client';

export default class VisitorsSettingsPoliciesNewController extends Controller {
  @service declare reactRenderer: ReactRendererService;

  private root?: Root;

  @action
  async injectComponent(): Promise<void> {
    const { CreatePolicy } = await import('reactRichComponents/visitors/CreatePolicy');

    this.root = await this.reactRenderer.render(CreatePolicy, 'react__visitors__settings__policies__new');
  }

  @action
  destroyComponent(): void {
    if (this.root) {
      this.reactRenderer.unmount(this.root);
      this.root = undefined;
    }
  }
}
